import './src/styles/global.scss';
import { handleRouteUpdate, installLinkTracking } from './src/lib/analytics';
// One page_view per real navigation; query-only updates and hydration repeats are ignored.
export const onRouteUpdate = ({ location, prevLocation }) => { handleRouteUpdate(location, prevLocation); };
export const onClientEntry = () => {
  // Delegated a[data-merchant][data-placement] / a[data-nav-cta] / a[data-result-position]: click + auxclick.
  installLinkTracking(document);
  // Retire the old offline cache so a visitor cannot keep the retired API UI.
  if ('serviceWorker' in navigator) navigator.serviceWorker.getRegistrations().then(registrations => registrations.forEach(registration => registration.unregister()));
};
